import React from 'react';
import TabStripLowDom from '@components-clean/core/tabstrip-low-dom';
import { useUnsavedChangesContext } from '@contexts-clean/unsaved-changes-context';
import './manage-hubs.scss';
import ManageHubsCentralMonitoring from '@pages-clean/admin/study/manage-hubs/central-monitoring';
import ManageHubsSubjectMonitoring from '@pages-clean/admin/study/manage-hubs/subject-monitoring';
import { useTranslation } from '@hooks/index';

const ManageHubsWrapper = () => {
    const { t } = useTranslation('admin');

    const { confirmDiscardChanges, anyComponentHasChanges, discardChanges } = useUnsavedChangesContext();

    return (
        <TabStripLowDom
            data={[
                {
                    title: t('centralMonitoring.mainTabName'),
                    content: <ManageHubsCentralMonitoring />,
                    dataTestId: 'manage-hubs-central-monitoring-tab',
                },
                {
                    title: t('subjectMonitoring.mainTabName'),
                    content: <ManageHubsSubjectMonitoring />,
                    dataTestId: 'manage-hubs-subject-monitoring-tab',
                },
            ]}
            canChangeTab={async () => {
                if (anyComponentHasChanges()) {
                    const confirmed = await confirmDiscardChanges();
                    if (!confirmed) {
                        return false;
                    }
                    discardChanges();
                }
                return true;
            }}
        />
    );
};

export default ManageHubsWrapper;
